import { Component, inject, Input, OnInit } from '@angular/core';
import { Aufgabe } from 'src/app/domain/model/aufgabe';
import { UflaUser } from '../../service/auth/ufla-user';
import { AuthenticationService } from '../../service/auth/authentication.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'ufla-aufgabe-card',
    templateUrl: './aufgabe-card.component.html',
    styleUrls: [
        './aufgabe-card.component.scss',
    ],
    standalone: false,
})
export class AufgabeCardComponent implements OnInit {
    authenticationService = inject(AuthenticationService);

    @Input() aufgabe: Aufgabe;

    zuweisungenNameIfLengthEq1 = undefined;

    public uflaUser: UflaUser;

    constructor() {
        this.authenticationService.user$
            .pipe(takeUntilDestroyed())
            .subscribe((user) => this.uflaUser = user);
    }

    ngOnInit() {
        if (this.aufgabe.zuweisungen.length === 1) {
            this.zuweisungenNameIfLengthEq1 = this.aufgabe.zuweisungen[0].zugewiesen.name;
        }
    }

    public get kurzbeschreibungShortened(): string {
        const tmp = this.aufgabe.kurzbeschreibung;
        return tmp == null ? '' : tmp.length > 100 ? tmp.substring(0, 100) + '...' : tmp;
    }

    public get anzahlZuweisungen(): number {
        return this.aufgabe.zuweisungen.length;
    }

    public get anzahlZuweisungenBestaetigt(): number {
        return this.aufgabe.zuweisungen.filter(z => z.gelesen).length;
    }

    public get prozentErledigt(): number {
        return Math.floor(this.anzahlZuweisungenBestaetigt / this.anzahlZuweisungen * 100);
    }

    public get prozentErledigtBar(): number {
        return Math.min(100, Math.ceil(this.prozentErledigt + 0.999));
    }

    public get colorProzentErledigt(): string {
        let color = 'green';
        if (this.prozentErledigt < 100) {
            color = 'orange';
        }
        if (this.prozentErledigt < 50) {
            color = 'red';
        }
        return color;
    }
}
